import { generateId } from '@freelancer/datastore/testing/helpers';
import type { UserContactPhone } from './user-contact-phone.model';

export interface GenerateUserContactPhoneOptions {
  readonly userId: number;
  readonly phone?: { readonly phoneCode: string; readonly phoneNumber: string };
}

export function generateUserContactPhoneObject({
  userId = generateId(),
  phone = undefined,
}: GenerateUserContactPhoneOptions): UserContactPhone {
  return {
    id: userId,
    phone,
  };
}
